"use client";

import React, { useEffect, useRef } from "react";

interface VideoBlockProps {
  block: {
    htmlContent?: string;
    [key: string]: any;
  };
  blockStyle?: React.CSSProperties;
  extraClass?: string;
}

const Video: React.FC<VideoBlockProps> = ({
  block,
  blockStyle,
  extraClass = "",
}) => {
  const videoContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (videoContainerRef.current) {
      const videoElement = videoContainerRef.current.querySelector("video");
      if (videoElement) {
        videoElement.classList.add("video-element", "w-full");
      }
    }
  }, []);

  if (!block.htmlContent) {
    return (
      <div className={`video-container ${extraClass}`} style={blockStyle}>
        <div className="bg-gray-100 p-4 text-center rounded"></div>
      </div>
    );
  }

  return (
    <div
      ref={videoContainerRef}
      className={`video-container relative ${extraClass}`}
      style={blockStyle}
      dangerouslySetInnerHTML={{ __html: block.htmlContent }}
    />
  );
};

export default Video;
